import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import AccountButton from 'src/presentation/components/molecules/AccountButton';
import { useHeaderStyle } from 'src/presentation/hooks/useHeaderStyle';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';
import { headerlessStackScreenOptions } from 'src/presentation/navigation/defaultScreenOptions';
import type { BathCardNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import BathCardsScreen from 'src/presentation/screens/BathCardsScreen';

const Stack = createStackNavigator<BathCardNavigation>();

export default function BathCardStackNavigator() {
	useActiveLanguage();

	const headerStyle = useHeaderStyle();

	return (
		<Stack.Navigator screenOptions={{ ...headerlessStackScreenOptions, title: Translations.tabsBathCard }}>
			<Stack.Screen
				component={BathCardsScreen}
				name={Constants.screenBathCardsList}
				options={{
					headerShown: true,
					headerStyle,
					headerRight: () => <AccountButton style={{ marginHorizontal: Dimens.padding18 }} />,
				}}
			/>
		</Stack.Navigator>
	);
}
